import axios from "axios";
import packageJson from "../../../package.json";

/**
 * Stamps every API request with the bundle version the tab is running.
 *
 * Set as a global axios default (imported once from main.jsx) so every
 * instance — createApi, createMonitoringAPICall, createRefreshApi, and any
 * inline axios.create — inherits it, including ones added in the future.
 * The camera-admin nginx log_format records the header, so support can
 * answer "which build is this customer's tab on" from the existing New
 * Relic logs (stale SPA tabs survive deploys until a full reload).
 *
 * Backend contract: x-app-version must be in CORS_ALLOW_HEADERS on
 * actuate_admin and actuate_monitoring_api, or preflights fail (ENG-423).
 * All axios usage in this app targets our own API; if a third-party axios
 * call is ever added, this header would ride along and its origin must
 * allow it — or use fetch() for that call instead.
 */
export const APP_VERSION = packageJson.version;

axios.defaults.headers.common["X-App-Version"] = APP_VERSION;
